import { LastModifiedCell } from 'ui/indexPages/tables/cells/LastModifiedCell';
import { Campaign } from '../domainTypes';
import { User } from '../types';

type Props = {
  campaign: Campaign;
  /** Lookup user info by id */
  userInfoLookup: { [key: string]: User };
};

export const CampaignLastModifiedCell = ({ campaign, userInfoLookup }: Props) => {
  const creator = userInfoLookup[campaign.createdBy];
  const createdBy = { emailAddress: campaign.createdBy, ...creator };

  let modifiedBy;
  if (campaign.updatedBy) {
    const modifier = userInfoLookup[campaign.updatedBy];
    modifiedBy = { emailAddress: campaign.updatedBy, ...modifier };
  }

  return (
    <LastModifiedCell
      createdBy={createdBy}
      modifiedBy={modifiedBy}
      createdAt={campaign.createdAt}
      modifiedAt={campaign.updatedAt}
    />
  );
};
